import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {Row, Col} from 'react-flexbox-grid'
import chroma from 'chroma-js'
import ReactTooltip from 'react-tooltip'
import {SlideDown} from 'react-slidedown'
import {
  Chart,
  FlaggedFund,
  Link,
  LinkIcon,
  Tweeter,
  FundName,
  FundShareTakeAction,
  IyvScorecard,
  Grade,
  InlineSignup,
} from '../../components'
import * as searchActions from 'redux/modules/search'
// import Modal from 'react-modal'
import moment from 'moment'

const Styles = require('./FundGunInvestments.css')

const FirstPage = 5
const AllPage = 1000000

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{
    return fHoldingsMap[o.id].market_value * -1
  })
  // .take(10)
  .value()
}

const propStateMap = [
  // { state:'screen', prop:'screen', transform:(value)=>value }
  { state:'err', prop:'err', transform:(value)=>value }
]

// // convert state to query props
// const propsFromState = (state) => {
//   const props = {}

//   propStateMap.forEach((map) => {
//     // in map
//     if (typeof state[map.state] !== 'undefined' && state[map.state] !== null) {
//       // has value after transform
//       const value = map.transform(state[map.state])

//       if (typeof value !== 'undefined' && value !== null) {
//         props[map.prop] = value
//       }
//     }
//   })

//   return props
// }
// convert query props to state
const stateFromProps = (props) => {
  // defaults
  const state = {
    // screen: 'all',
    location: props.location
  }

  propStateMap.forEach((map) => {
    // in map
    if (props.location.query[map.prop]) {
      // has value after transform
      const value = map.transform(props.location.query[map.prop])

      if (typeof value !== 'undefined' && value !== null) {
        state[map.state] = value
      }
    }
  })

  return state
}

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
    // sector: state.sector.result
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundGunInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    // sector: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = Object.assign(stateFromProps(props), {
      weaponsPage: 1,
      activeSector: '',
      viewMore: false,
      // showScreens: false,
    })
  }
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    // const sector = this.props.sector ? this.props.sector : {}
    // let screen = ''
    // if (sector && sector.mil && !sector.civ) {
    //   screen = 'mil'
    // } else if (sector && !sector.mil && sector.civ) {
    //   screen = 'civ'
    // } else if (sector && sector.mil && sector.civ) {
    //   screen = 'all'
    // } else {
    //   screen = this.state.screen || 'all'
    // }
    // const validScreen = ['mil', 'civ', 'all'].includes(screen)
    // if (!validScreen) {
    //   screen = 'all'
    // }
    // this.selectScreen(screen)
  }
  componentDidMount() {
    // window.addEventListener('scroll', this.handleScroll)
    analytics.event(analytics.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId))
    this._mounted = true
  }

  componentWillReceiveProps(props) {
    const ele = document.getElementById('anchor-top')
    window.scrollTo(ele.offsetLeft,ele.offsetTop)
    // if (props.location !== this.state.location) {
      // const state = Object.assign(this.state, stateFromProps(props))
      // this.selectScreen(state.screen)
    // }
  }

  componentWillUnmount() {
    this._mounted = false
  }

  getChartData = (fund, weaponHoldings, fHoldingsMap, label, _allAsset, _allWeight, _allRating) => {
    // colors
    const colors = {
      'gm':'#C3001C',
      'gm_end':'#C3001C',
      'gr':'#F2961C',
      'gr_end':'#F2961C',
      'weapons':'#C3001C',
      'weapons_lite':'#F2961C',
      'gray':'#D5D5D5',
      'green':'#D5D5D5'
    }
    // what categories are active?
    const activeSector = this.state.activeSector
    const allAsset = convert.int(fund[_allAsset])
    const allWeight = format.perc(fund[_allWeight])
    const fundRating = convert.float(fund[_allRating])
    const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1)
    // const capitalizedLabel = 'Gun manufacturers and major gun retailers'
    let chartData = []

    if (activeSector && allAsset > 0) {
      // companies
      const num_colors = convert.int(fund[activeSector+'_count'])
      const scaleStart = colors[activeSector]
      let scaleEnd = colors[activeSector+'_end']
      if (weaponHoldings.length === 1) {
        scaleEnd = scaleStart
      }
      const f = chroma.scale([scaleStart,scaleEnd]).mode('rgb').colors(num_colors)
      // const shuffled = format.shuffle(f)
      let currIdx = -1
      // // map holdings to pie chart data
      chartData = weaponHoldings.reduce( (filtered, holding) => {
        const nameLabel = format.longString(holding.security_name, 20)
        const moneyLabel = format.money(fHoldingsMap[holding.id].market_value, true, 'USD', true)
        currIdx = (currIdx + 1) % num_colors
        filtered.push({
          value: fHoldingsMap[holding.id].market_value,
          label: nameLabel + ' ' + moneyLabel,
          color: f[currIdx]
        })
        return filtered
      }, [])
    } else {
      if (allAsset > 0) {
        const isLite = (fundRating === 2.0)
        chartData = [{
          value: allAsset,
          label: capitalizedLabel + ' stocks: '+allWeight,
          color: isLite ? colors.weapons_lite : colors.weapons
        },{
          value: convert.int(fund.fund_net_assets) - allAsset,
          label: 'All other holdings',
          color: colors.gray
        }]
      } else {
        chartData = [{
          value: 1,
          label: 'No ' + label + ' stock holdings',
          color: colors.green
        }]
      }
    }
    return chartData
  }

  clickViewMore = () =>{
    this.setState({viewMore: !this.state.viewMore})
  }

  // toggleScreens = () =>{
  //   this.setState({ showScreens: !this.state.showScreens })
  // }

  // selectScreen = (name) => {
  //   let sector = {}

  //   switch (name) {
  //     case 'all':
  //       sector = { mil: true, civ: true }
  //       break
  //     case 'mil':
  //       sector = { mil: true, civ: false }
  //       break
  //     case 'civ':
  //       sector = { mil: false, civ: true }
  //       break
  //   }

  //   this.props.sectorChange(sector)

  //   const fundName = this.props.params.name
  //   const ticker = this.props.params.ticker
  //   const fundId = this.props.params.fundId
  //   const investmentVehicleId = this.props.params.investmentVehicleId
  //   const url = config.routes.fund+'/'+fundName+'/'+ticker+'/weapon-investments/'+fundId+'/'+investmentVehicleId

  //   this.setState({
  //     activeSector: '',
  //     weaponsPage: 1,
  //     showScreens: false
  //   })

  //   // if it's a new screen, update the query
  //   if (name !== this.state.screen) {
  //     this.context.router.push({
  //       pathname: url,
  //       query: propsFromState( Object.assign(this.state,
  //         {screen: name}) )
  //     })
  //   }
  // }

  clickSector(newSector){
    this.setState({
      activeSector: (newSector === this.state.activeSector) ? '' : newSector,
      weaponsPage: 1
    })
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState( newState )
    }
  }

  holdingsCount = ( count ) => {
    if( count > 0 ){
      return format.number(count) + ' holdings'
    }

    return ''
  }

  renderHoldings = ( shareClass, fHoldingsMap, holdings, page ) => {
    if( !holdings || holdings.length === 0 ){
      return ( <div styleName='holdings-none'>NONE</div> )
    }

    const takeCount = (page > 1) ? AllPage : FirstPage

    const iconGm = require( '../../../static/images/icn-gm-active.svg' ) // no-circle
    const iconGr = require( '../../../static/images/icn-gr-active.svg' ) // no-circle

    const iconConfigs = [
      ['is_gm', iconGm, 'Civilian firearm manufacturers'],
      ['is_gr', iconGr, 'Civilian firearm retailers'],
    ]

    return chain(holdings)
      .take(takeCount)
      .map( (h,idx) =>{
        const fPerc = format.perc(fHoldingsMap[h.id].long_weight)
        const fMoney = format.money(
          fHoldingsMap[h.id].market_value,
          true,
          shareClass.currency,
          true
        )
        //
        return (
          <li
            key={idx}
            styleName='holding'
          >
            <div styleName='holding-name'>
              <div>
                {idx+1}. {h.security_name}
              </div>
              <div>
                { /* mini-sector icons */
                  iconConfigs.map((sector)=>{
                    return h[sector[0]] ?
                      (
                        <span
                          key={sector[0]}
                          title={sector[2]}
                        >
                          <img
                            styleName='detail-icon-holding'
                            src={sector[1]}
                            alt={sector[2]}
                          />
                        </span>
                      ) :
                      null
                  })
                }
              </div>
            </div>
            <div styleName='holding-invested'>
              {fMoney}
            </div>
            <div styleName='holding-asset'>
              {fPerc}
            </div>
          </li>
        )
      })
      .value()
  }

  renderCompanies = (shareClass, fHoldingsMap, type, label, count, holdings, page) => {
    count = convert.int(count)
    const hasMoreButton = (page === 1 && count > FirstPage) ?
      ( <div styleName={'detail-more-'+type}
       onClick={this.increment( 'weaponsPage' ) }>See all<LinkIcon faclass='fa-angle-down'/></div> ) : null

    if( count === 0 ){
      return null
    }

    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName={'detail-fossils'}>
          <div styleName='detail-title-holdings'>
            <div styleName={'detail-title-'+type}>{label}</div>
            <div styleName={'visible-sm visible-md visible-lg detail-holdings-count-'+type}>
              { this.holdingsCount(count) }
            </div>
          </div>
          <div styleName={'visible-xs mobile-holdings-label'}>
            {count} holdings
          </div>
          <ul styleName='detail-holdings'>
            { this.renderHoldings(shareClass, fHoldingsMap, holdings, page) }
          </ul>
        </div>
        {hasMoreButton}
      </Col>
    )
  }

  renderSectorDetailsSwitch = (type, label, sublabel, count, weight, asset, currency) => {
    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'.svg' )
    // circle icon filled in
    const iconActive = require( '../../../static/images/icn-'+type+'-active.svg' )
    // circle icon with green slash
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive-slash.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // currently active?
    const isActive = (type===this.state.activeSector)
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      if (isActive){
        cleanDirtyStyle = 'detail-sector-'+type+'-active'
        currIcon = iconActive
      } else {
        cleanDirtyStyle = 'detail-sector-'+type+'-normal'
        currIcon = iconNormal
      }
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    const clickSectorFn = (sectorType) => {
      if (isDirty) {
        this.clickSector(sectorType)
      }
    }

    return (
      <div
        styleName='detail-sector-wrapper'
        onClick={ () => clickSectorFn(type) }
      >
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName='detail-title-active'>
            <div>{ label }</div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>{ sublabel }</div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.number(count) }
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.money(asset, true, currency, true) }
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.perc(weight) }
                    </div>
                    <div styleName='detail-stat-label'>of portfolio</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-title'>
                      0 direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }

        </div>
      </div>
    )
  }

  // renderScreenSwitches = (activeLabel) => {
  //   function renderScreenOption(stateScreen, selectScreen, screen, label) {
  //     return (
  //       <button
  //         onClick={() => selectScreen(screen)}
  //         styleName='adjust-screens-option'
  //         role='button'
  //         tabIndex='0'
  //       >
  //         <div styleName='adjust-screens-option-inner'>
  //           <div styleName='adjust-screens-option-label'>
  //             {label}
  //           </div>
  //           <div styleName='adjust-screens-option-icon'>
  //             <i
  //               styleName='adjust-screens-icon'
  //               className={ stateScreen===screen ? 'fa fa-check-circle':'fa fa-circle-thin' }
  //             />
  //           </div>
  //         </div>
  //       </button>
  //     )
  //   }

  //   return (
  //     <div styleName='adjust-screens-wrap'>
  //       <button
  //         styleName='adjust-screens'
  //         onClick={this.toggleScreens}
  //         role='button'
  //         tabIndex='0'>

  //         <span styleName='adjust-screens-text'>
  //           <LinkIcon
  //             nospace
  //             faclass='fa-sliders'
  //           />
  //           &nbsp;
  //           Screen settings: {activeLabel}
  //           <LinkIcon
  //             faclass={this.state.showScreens
  //                      ? 'fa-angle-up'
  //                      : 'fa-angle-down'}
  //           />
  //         </span>

  //       </button>
  //       {
  //         (!this.state.showScreens) ?
  //         (<div/>) :
  //         (
  //           <div styleName='adjust-screens-panel'>
  //             { renderScreenOption(this.state.screen, this.selectScreen, 'all', 'All weapons') }
  //             { renderScreenOption(this.state.screen, this.selectScreen, 'mil', 'Military weapons') }
  //             { renderScreenOption(this.state.screen, this.selectScreen, 'civ', 'Civilian firearms') }
  //           </div>
  //         )
  //       }
  //     </div>
  //   )
  // }


  renderMore = (shareClass,showDataAs) => {
    return (
      <div styleName="more-stats">
        {this.renderMoreButton(shareClass.date,true)}
        <SlideDown>
          { (this.state.viewMore)  ? this.renderStats(shareClass) : null}
        </SlideDown>
      </div>
      )
  }

  renderMoreButton = (portfolioDate,showDataAs) => {
    const label = (!this.state.viewMore ) ? 'View more info' : 'View less'
    return(
      <div styleName="view-more-wrapper">
        <button styleName="view-more" title={label} onClick={this.clickViewMore}>
          {label}
          <LinkIcon faclass={this.state.viewMore?'fa-angle-up':'fa-angle-down'} />
        </button>
      </div>
    )
  }

  renderStats = (shareClass) => {
    function renderCol(type, entries, hasLine) {
      return (
        <Col xs={6} styleName={'col-'+type+'-wrapper'}>

          {
            entries.map((entry,idx) => {
              return (
                <div
                  key={idx}
                  styleName='col-label-value'>

                  <div styleName={'col-'+type}>
                    <div styleName='stats-label'>{entry.name}</div>

                    {
                      (entry.link) ? (
                        <Link
                          to={entry.link}
                          title={entry.value}>
                          <div styleName='stats-value-link'>{entry.value}</div>
                        </Link>
                      ) : <div styleName='stats-value'>{entry.value}</div>
                    }

                  </div>

                  {
                    (hasLine && (idx !== entries.length-1)) ? (
                      <div styleName='col-line'/>
                    ) : null
                  }

                </div>
              )
            })
          }

        </Col>
      )
    }

    const dest = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>

          <Row styleName='stats-header'>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div styleName='stats-title'>
                Mutual fund investment profile
              </div>
            </Col>
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass ticker', value:shareClass.ticker}], false) }
            { renderCol('right', [{name: 'Data as of', value:moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass name', value:shareClass.name}], false) }
            { renderCol('right', [{name: '% of fund assets screened', value:format.perc(shareClass.percent_rated) }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass type', value:format.legalType(shareClass.legal_type)}], false) }
            { renderCol('right', [{name: 'Fund net assets', value:format.money(shareClass.fund_net_assets, true, shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Fund family', link:config.routes.families+'?q='+dest, value:shareClass.fund_family_name}], false) }
            { renderCol('right', [{name: 'Fund group', value:shareClass.category_group }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Domicile country', value:format.market(shareClass.market)}], false) }
            { renderCol('right', [{name: 'Portfolio currency', value:format.currencyCode(shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Sustainability mandate', value:format.boolean(shareClass.ussif || "0")}], false) }
            { renderCol('right', [{name: '', value: ''}], false) }
          </Row>

          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Civilian firearm totals
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total civilian firearm stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.wff_civ_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in civilian firearm stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.wff_civ_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in civilian firearm stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.wff_civ_asset, true, shareClass.currency, false) }
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Civilian firearm grade</div>
              <div styleName='profile-grade-title'>
                <Grade grade={shareClass.grade_tobacco}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderSectors = (sector, fund, shareClass, fHoldingsMap) => {
    return (
      <div key={sector[0]}>
        { /* render the sector switch */
          this.renderSectorDetailsSwitch(sector[0], sector[1], sector[2],
            fund[sector[3]], fund[sector[4]], fund[sector[5]],
            shareClass.currency)
        }
        <SlideDown>
          { /* render the holding list if the sector is active */
            (this.state.activeSector === sector[0])
            ? this.renderCompanies(shareClass, fHoldingsMap, sector[0],
                sector[1], shareClass[sector[3]], sector[6],
                this.state.weaponsPage)
            : null
          }
        </SlideDown>
      </div>
    )
  }

  render() {
    if( !this.props.result ){
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    } else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    // const sriIcon = require( '../../../static/images/sri.svg' )
    // const ussifIcon = require( '../../../static/images/ussif-memberlogo.png' )

    function renderGradeBox(label, _grade, screen) {
      const rating = fund[_grade]
      const letterGrade = format.score(rating)
      const sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade
      const scoreTip = format.weaponGradeTooltip('civ', letterGrade)

      const descriptions = {
        A: 'No holdings flagged for our civilian firearm screens. Assigned a grade of A.',
        B: 'Fund is invested in civilian firearm retailers, but no holdings flagged for our civilian firearm manufacturers screen. Assigned a grade of B.',
        C: 'Fund is invested in civilian firearm manufacturers, below the threshold of 0.1%. Assigned a grade of C.',
        D: 'Fund is invested in civilian firearm manufacturers, above the threshold of 0.1% and below 0.4%. Assigned a grade of D.',
        F: 'Fund is invested in civilian firearm manufacturers, above the threshold of 0.4%. Assigned a grade of F.',
        NA: 'Error',
      }
      const description = descriptions[sfGrade]

      return (
        <div styleName='grade-snapshot'>
          <div styleName='grade-intro'>
            <span>
              <strong>{label} grade:</strong> {description}
            </span>
            <br/>
            <Link
              strong
              to={config.routes.howitworks}
              title='How it works'
            >
              <strong>How we track gun investments<LinkIcon /></strong>
            </Link>
          </div>
          <div
            styleName='grade-wrapper'
            data-multiline
            data-effect='solid'
            data-tip={scoreTip}
            data-html
            data-place='bottom'
            data-for='tooltip-grade'
          >
            <Grade grade={rating} large />
          </div>
          <ReactTooltip id='tooltip-grade'/>
        </div>
      )
    }

    const shareClass = this.props.result.shareClass
    const title = shareClass.fund_legal_name + ' | Gun investments'
    const fund = this.props.result.fund
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/gun-investments/'+urlEnd

    // could this be cached (e.g. in state) to improve performance?
    const fHoldingsMap = mapFundHoldings(this.props.result.fund.fundholdings)
    // const weaponHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
    //   return(o.is_gm  ||
    //          o.is_gr)
    // })
    const civHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_gm  ||
             o.is_gr)
    })
    const gmHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_gm)
    })
    const grHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_gr)
    })

    let allHoldings = null
    let chartMessage = null
    let label = null
    let activeLabel = null
    let allCount = null
    let allAsset = null
    let allWeight = null
    let allRating = null
    // let showMil = false
    let showCiv = false

    switch (this.state.screen) {
      default:
        allHoldings = civHoldings
        chartMessage = 'Civilian firearms'
        label = 'gun'
        activeLabel = 'Civilian firearms'
        allCount = config.fundFields.CIV_COUNT
        allAsset = config.fundFields.CIV_ASSET
        allWeight = config.fundFields.CIV_WEIGHT
        allRating = config.fundFields.CIV_RATING
        showCiv = true
        break
    }
    const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1)

    shareClass.gm_weight = fund.gm_weight
    shareClass.gr_weight = fund.gr_weight

    return (
      <div>
        {container.helmet(title, '', url)}

        { /* <FundMenu
          active={'Weapon investments'}
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
          screen={this.state.screen}
        /> */ }

        <FundName shareClass={shareClass}
          pathname={this.props.location.pathname} />

        <div styleName='main'>
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>

              <Row>
                <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>
                  { renderGradeBox(capitalizedLabel, allRating, this.state.screen) }
                  {
                    this.state.activeSector==='' && convert.int(fund[allAsset])>0 ?
                      (
                        <Chart
                          currency={shareClass.currency}
                          invested={convert.int(fund[allAsset])}
                          chartData={
                            this.getChartData(
                              fund,
                              allHoldings,
                              fHoldingsMap,
                              label,
                              allAsset,
                              allWeight,
                              allRating
                            )
                          }
                          chartMessage={chartMessage}
                        />
                      ) :
                      null
                  }
                  {
                    this.state.activeSector==='gm' && convert.int(fund[allAsset])>0 ?
                      (
                        <Chart
                          currency={shareClass.currency}
                          invested={convert.int(fund.gm_asset)}
                          chartData={
                            this.getChartData(
                              fund,
                              gmHoldings,
                              fHoldingsMap,
                              label,
                              allAsset,
                              allWeight,
                              allRating
                            )
                          }
                          chartMessage='Gun manufacturers'
                        />
                      ) :
                      null
                  }
                  {
                    this.state.activeSector==='gr' && convert.int(fund[allAsset])>0 ?
                      (
                        <Chart
                          currency={shareClass.currency}
                          invested={convert.int(fund.gr_asset)}
                          chartData={
                            this.getChartData(
                              fund,
                              grHoldings,
                              fHoldingsMap,
                              label,
                              allAsset,
                              allWeight,
                              allRating
                            )
                          }
                          chartMessage='Major gun retailers'
                        />
                      ) :
                      null
                  }
                  <FlaggedFund
                    count={convert.int(fund[allCount])}
                    weight={convert.float(fund[allWeight])}
                    asset={convert.int(fund[allAsset])}
                    portfolioDate={fund.date}
                    label={label}
                  />
                </Col>
                <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
                  {
                    this.state.screen === 'civ' && convert.int(fund[config.fundFields.CIV_COUNT])===0 ?
                      (
                        <div styleName='flagged-fund-clean'>
                          <div styleName='flagged-fund-clean-title'>
                            This fund is clean for both of our civilian
                            firearm categories!
                          </div>
                        </div>
                      ) :
                      null
                  }
                  <div styleName='sector-details-info'>
                    <i className='fa fa-info-circle'/> For each civilian firearm category,
                    we show the fund's exposure. Click a category to see the
                    breakdown of companies. When calculating a portfolio's
                    exposure to a screen list, we
                    only consider long investments, ignoring any shorts or 
                    liabilities.
                  </div>
                  {
                    showCiv ?
                      (
                        <div>
                          <div styleName='sector-details-info-label-utility'>
                            Civilian firearms
                          </div>
                          { /* Sector switches + company lists */
                            [
                              [
                                'gm',
                                'Gun manufacturers',
                                'Manufacturers of civilian firearms',
                                'gm_count',
                                'gm_weight',
                                'gm_asset',
                                gmHoldings
                              ],
                              [
                                'gr',
                                'Major gun retailers',
                                'Largest public retailers of civilian firearms',
                                'gr_count',
                                'gr_weight',
                                'gr_asset',
                                grHoldings
                              ]
                            ]
                            .map((sector)=>{
                              return this.renderSectors(
                                sector,
                                fund,
                                shareClass,
                                fHoldingsMap
                              )
                            })
                          }

                        </div>
                      ) :
                      null
                  }
                  {
                    convert.int(fund[allCount]) ?
                      (
                        <div>
                          <div>
                            {
                              this.state.activeSector === '' ?
                                this.renderCompanies(
                                  shareClass,
                                  fHoldingsMap,
                                  'weapons',
                                  'Gun manufacturers and major gun retailers',
                                  shareClass[allCount],
                                  allHoldings,
                                  this.state.weaponsPage
                                )
                              : null
                            }
                          </div>
                        </div>
                      ) :
                      (
                        <div styleName='clean-funds-link'>
                          <div styleName='clean-funds-headline'>
                            Want to learn how to add gun free funds to your
                            retirement plan?
                          </div>
                          <div styleName='clean-funds-info'>
                            Use our Gun Free Action Toolkit and get started
                            moving your money
                          </div>
                          <div styleName='clean-funds-btn-wrap'>
                            <Link
                              to={config.routes.toolkit}
                              roundbutton
                              title='Action toolkit'
                            >
                              <div>
                                Action toolkit<LinkIcon />
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                  }
                </Col>
              </Row>

              <br/>
              <br/>
              <br/>
              
              { this.renderMore(shareClass) }

              <br/>
              <br/>
              <br/>

              <InlineSignup />

            </div>
          </div>
        </div>
        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />

        <br/>
        <br/>
        <br/>

        <FundShareTakeAction
          fund={fund}
          shareClass={shareClass}
          url={url}
          screen={this.state.screen}
        />
      </div>
    )
  }
}
